<template>
    <div class="login-container">
        <div class="banner-wrap">
            <el-carousel height="100vh">
                <el-carousel-item :key="item" v-for="item in bannerList">
                    <el-image
                        :src="require(`@/assets/image/login/${item}`)"
                        fit="contain"
                    ></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="login-wrap">
            <div class="login-box">
                <h2 class="login-box-title">LOGIN CMOFFER</h2>
                <div class="login-box-form">
                    <el-form
                        :model="loginForm"
                        :rules="rules"
                        :show-message="true"
                        class="form-wrap"
                        ref="loginForm"
                    >
                        <el-form-item label="Email" prop="email">
                            <el-input
                                @blur="
                                    transformLabel(0, 'blur', loginForm.email)
                                "
                                @clear="
                                    transformLabel(0, 'blur', loginForm.email)
                                "
                                @focus="transformLabel(0, 'focus')"
                                @keyup.enter.native="handleLogin"
                                clearable
                                maxlength="100"
                                ref="email"
                                v-model="loginForm.email"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Password" prop="password">
                            <el-input
                                @blur="
                                    transformLabel(
                                        1,
                                        'blur',
                                        loginForm.password
                                    )
                                "
                                @clear="
                                    transformLabel(
                                        1,
                                        'blur',
                                        loginForm.password
                                    )
                                "
                                @focus="transformLabel(1, 'focus')"
                                @keyup.enter.native="handleLogin"
                                maxlength="100"
                                ref="password"
                                show-password
                                clearable
                                type="password"
                                v-model="loginForm.password"
                            >
                            </el-input>
                        </el-form-item>
                        <div class="auto-login-forgot-pwd-div">
                            <el-checkbox v-model="loginForm.autoLogin"
                                >Automatic login within 5 days</el-checkbox
                            >
                            <el-button @click="changePassword" type="text"
                                >Forgot password</el-button
                            >
                        </div>
                        <el-button
                            :class="[
                                'login-btn',
                                {
                                    'login-submit-btn':
                                        loginForm.login_name &&
                                        loginForm.login_password,
                                },
                            ]"
                            :loading="loading"
                            @click="handleLogin()"
                            >Login</el-button
                        >
                        <div class="privacy-policy-div">
                            <span>Don't have an account?</span>
                            <el-button type="text" @click="register"
                                >Register Now</el-button
                            >
                        </div>
                        <!-- <div class="privacy-policy-div">
                            <div
                                class="user-activation"
                                @click.capture="activate"
                            >
                                <el-image
                                    :src="
                                        require('@/assets/image/login/user-activation.jpg')
                                    "
                                    :lazy="true"
                                ></el-image>
                                <div class="mask"></div>
                            </div>
                        </div> -->
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import util from "@/utils/util.js";
export default {
    data() {
        return {
            loginForm: {
                email: "",
                password: "",
                autoLogin: true,
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: "Please input",
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Please input",
                        trigger: "blur",
                    },
                ],
            },
            provinceList: [],
            cityList: [],
            checked: false,
            loading: false,
            language: 1,
            languageList: [
                {
                    id: 1,
                    label: "English",
                },
                {
                    id: 2,
                    label: "中文",
                },
            ],
            formItemLabels: null,
            bannerList: ["banner-1.jpg", "banner-2.jpg"],
            redirect: new URL(location.href).searchParams.get('ref') || '/home'
        };
    },
    created() {
        if (localStorage.getItem("token")) {
            this.$store.dispatch("getUserInfo");
            this.$router.push({
                path: "/home",
            });
        }
    },
    mounted() {
        this.initFormItemLabel();
    },
    watch: {
        ["loginForm.email"]: {
            handler(val) {
                this.$nextTick(() => {
                    if (this.formItemLabels) {
                        if (val) {
                            this.transformLabel(0, "focus");
                        }
                    }
                });
            },
            immediate: true,
        },
        ["loginForm.password"]: {
            handler(val) {
                this.$nextTick(() => {
                    if (this.formItemLabels) {
                        if (val) {
                            this.transformLabel(1, "focus");
                        }
                    }
                });
            },
            immediate: true,
        }
    },
    methods: {
        /**
         * 登录
         */
        handleLogin() {
            this.$refs["loginForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let data = {
                        password: this.loginForm.password,
                        expires_in:
                            (this.loginForm.autoLogin && "5 days") || "1 day",
                    };
                    if (this.loginForm.email) {
                        if (util.isEmail(this.loginForm.email)) {
                            data.email = this.loginForm.email;
                        } else {
                            data.email = this.loginForm.email;
                        }
                    } else {
                        data.mobile = this.loginForm.phone;
                    }
                    cmofferApi.login(data, "post").then((res) => {
                        const { errcode, token, last_name, role, platform, store } = res;
                        if (errcode === 0) {
                            localStorage.setItem("token", token);
                            localStorage.setItem("last_name", last_name);
                            this.$store.dispatch("getUserInfo");
                            localStorage.setItem("roleId", role);
                            sessionStorage.removeItem("token_ptk");
                            platform && store && (sessionStorage.setItem('authTip', `${platform}-${store}`));
                            location.href = this.redirect
                            // this.$router.push({
                            //     path: redirect,
                            // });
                        }
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        /**
         * 修改密码提示框
         */
        changePassword() {
            /* this.$alert("请联系管理员重置密码", "提示", {
                confirmButtonText: "确定",
                type: "warning",
            }); */
            this.$router.push({
                path: "/forgot",
                query: {
                    email: this.loginForm.email,
                },
            });
        },
        transformLabel(i, type, val) {
            if (type == "focus") {
                this.formItemLabels[
                    i
                ].className = `el-form-item__label is-foucs`;
            } else if (type == "blur" && !val) {
                this.formItemLabels[i].className = `el-form-item__label`;
            }
        },
        initFormItemLabel() {
            this.formItemLabels = document.querySelectorAll(
                ".el-form-item__label"
            );
            this.formItemLabels[0].addEventListener("click", () => {
                this.$refs.email.focus();
            });
            this.formItemLabels[1].addEventListener("click", () => {
                this.$refs.password.focus();
            });
        },
        // 注册
        register() {
            location.href = `/register.html?ref=${encodeURIComponent(this.redirect)}`;
        },
        // 激活
        activate() {
            this.$router.push({
                path: "/activate",
                query: {
                    email: this.loginForm.email,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.login-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    position: relative;

    .banner-wrap {
        flex: 0 1 550px;
        background: #373330;
        transition: all 0.6s;

        ::v-deep .el-carousel {
            .el-carousel__item {
                &:nth-child(odd) {
                    background: #d3dce6;
                }

                &:nth-child(even) {
                    background: #99a9bf;
                }
            }

            .el-carousel__arrow {
                display: none;
            }

            .el-carousel__indicators--horizontal {
                bottom: 50px;

                .el-carousel__indicator--horizontal {
                    .el-carousel__button {
                        width: 22px;
                        height: 7px;
                        border-radius: 4px;
                    }
                }

                .is-active {
                    .el-carousel__button {
                        width: 44px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 900px) {
        .banner-wrap {
            flex: 0 1 0;
        }
    }

    .login-wrap {
        flex: 1 1 auto;
        background: #ffffff;
        position: relative;
        text-align: left;

        .login-box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // min-width: 490px;
            width: 510px;
            min-height: 480px;
            padding: 10px;
            color: $color-000000a6;
            box-sizing: border-box;

            .login-box-title {
                font-size: 26px;
                font-weight: bold;
                margin-bottom: 30px;
                color: #1c2d42;
            }

            .login-box-form {
                // 修改element 样式
                ::v-deep .el-form {
                    .el-form-item {
                        position: relative;
                        margin-bottom: 18px;

                        .el-form-item__label {
                            color: #a9b7d4;
                            line-height: 18px;
                            transform-origin: 0;
                            transition: transform 0.6s;
                            position: relative;
                            z-index: 10;
                            transform: translateY(25px) scale(1.2);

                            &::before {
                                content: "";
                            }

                            &.is-foucs {
                                transform: translateY(0) scale(1);
                            }
                        }

                        .el-form-item__content {
                            .el-input {
                                z-index: 12;

                                .el-input__inner {
                                    border: none;
                                    border-bottom: 1px solid #eaedf2;
                                    padding: 0 0 15px 3px;
                                    font-size: 16px;
                                    transition: border 0.6s;
                                    background-color: transparent;

                                    &:focus {
                                        border-bottom-color: $color-primary !important;
                                    }
                                }
                            }
                        }
                    }

                    .el-form-item.is-error {
                        .el-form-item__content {
                            .el-input {
                                .el-input__inner {
                                    border-bottom-color: #f00;
                                }
                            }
                        }
                    }

                    .auto-login-forgot-pwd-div {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .el-checkbox {
                            .el-checkbox__input {
                                .el-checkbox__inner {
                                    width: 16px;
                                    height: 16px;
                                    background-color: #fff !important;
                                    border-color: #606266 !important;
                                    color: #606266 !important;

                                    &::after {
                                        top: 2px;
                                        left: 5px;
                                        border-color: #202020 !important;
                                    }
                                }
                            }

                            .el-checkbox__label {
                                color: #606266 !important;
                            }
                        }

                        .el-button--text {
                            span {
                                color: $color-000000a6;
                            }
                        }
                    }

                    .login-btn {
                        color: #fff;
                        min-height: 50px;
                        line-height: 50px;
                        margin: 25px 0 15px;
                        cursor: pointer;
                        background: $color-primary;
                        width: 100%;
                        padding: 0;
                        border-radius: 0.015rem;
                        border: none;
                        outline: none;
                        font-size: 18px;

                        &:hover {
                            color: rgb(240, 240, 240);
                        }
                    }

                    .login-submit-btn {
                        background: #aed2e1;
                    }

                    .privacy-policy-div {
                        text-align: right;
                        color: $color-000000a6;
                        font-size: 13px;

                        span:first-child {
                            margin-right: 5px;
                        }

                        .and {
                            margin: 0 5px 0 3px;
                        }

                        .el-button--text {
                            font-size: 14px;
                            color: $color-primary;
                        }

                        .user-activation {
                            position: relative;
                            cursor: pointer;
                            overflow: hidden;

                            .mask {
                                // content: "";
                                display: block;
                                position: absolute;
                                left: -1%;
                                top: -116%;
                                width: 500px;
                                height: 500px;
                                border-radius: 50%;
                                background-color: $color-primary;
                                opacity: 0;
                                z-index: 101;
                                transform: scale(0.2);
                                transition: all 0.25s ease-out;
                            }

                            &:hover .mask {
                                transform: scale(1);
                                opacity: 0.1;
                                transition: transform 0.25s ease-out;
                            }
                        }
                    }

                    .other-login {
                        display: flex;
                        justify-content: space-evenly;
                        margin-top: 30px;

                        .dingtalk,
                        .wechat,
                        .phone {
                            position: relative;
                            cursor: pointer;
                            display: flex;
                            flex-direction: column;
                            align-items: center;

                            img {
                                width: 40px;
                                filter: blur(0px) opacity(1);
                                transition: filter 200ms linear,
                                    transform 200ms linear;
                            }

                            .label {
                                margin-top: 12px;
                                font-size: 14px;
                                transition: filter 200ms linear,
                                    transform 200ms linear;
                            }

                            /* &:hover {
                                img,.label {
                                    filter: saturate(1.5);
                                    transform: scale(1.05);
                                }
                            } */
                        }

                        .dingtalk {
                            &:hover {
                                .label {
                                    color: #3296fa;
                                }
                            }
                        }

                        .wechat {
                            &:hover {
                                .label {
                                    color: #28c445;
                                }
                            }
                        }

                        .phone {
                            &:hover {
                                .label {
                                    color: #e9af76;
                                }
                            }
                        }
                    }
                }
            }
        }

        .language-box {
            position: absolute;
            right: 15%;
            top: 150px;
            display: flex;
            align-items: center;

            .icon {
                width: 16px;
                margin-right: 5px;
            }

            ::v-deep.el-select {
                .el-input {
                    .el-input__inner {
                        width: 80px;
                        padding: 0;
                        border: none;
                    }

                    .el-input__suffix {
                        right: 9px;
                    }
                }
            }
        }
    }
}
</style>
